export default "__VITE_ASSET__1435a46d__"